<template>
    <div class="formModel">
        <Card>
            <Row type="flex" justify="space-between">
                <Col :span="24">
                    <Row>
                       <Form
                            ref="searchForm"
                            :model="searchForm"
                            inline
                            :label-width="100"
                            class="search-form">
                            <Form-item label="合作方中文名称">
                                <Input type="text" v-model="searchForm.partnerName" placeholder="请输入" clearable/>
                            </Form-item>
                            <Form-item label="合作方英文名称">
                                <Input type="text" v-model="searchForm.cooperationUnit" placeholder="请输入" clearable/>
                            </Form-item>
                            <Form-item label="合作方类型">
                                <Select
                                    v-model="searchForm.partnerType" 
                                    style="width: 200px"
                                    clearable>
                                    <Option value="0">国际</Option>
                                    <Option value="1">港澳台</Option>
                                </Select>
                            </Form-item>
                            <Form-item label="合作方性质">
                                <Select
                                    v-model="searchForm.partnerNature" 
                                    style="width: 200px"
                                    clearable>
                                    <Option 
                                        v-for="item in partnerNatureList" 
                                        :value="item.value" 
                                        :key="item.id">{{item.title}}</Option>
                                </Select>
                            </Form-item>
                            <Form-item style="margin-left: -35px" class="br">
                                <Button @click="searchData" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="addData" type="primary" icon="md-add">新增合作方</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新数据</Button>
                    </Row>
                    <Row style="margin-top:20px">
                        <Table :loading="loading" border :columns="columns" :data="data" sortable="custom" ref="table">
                            <template slot-scope="{ row }" slot="type">
								<div>{{row.partnerType==0?'国际':'港澳台'}}</div>
							</template>
                            <template slot-scope="{ row }" slot="operate">
								<div class="operate-slot">
									<i-button  type="primary" @click="editData(row.id)" size="small" class="margin_r_15">编辑</i-button>
									<i-button  type="error" @click="deleteData(row.id,row.partnerName)" size="small">删除</i-button>
								</div>
							</template>
                        </Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <v-page 
                            :pageNumber = searchForm.pageNumber 
                            :total="total" 
                            :pageSize = searchForm.pageSize
                            @changPage = changePage
                            @changePageSize = changePageSize>
                        </v-page>
                    </Row>
                </Col>
            </Row>
        </Card>
        <v-operation-model 
			:modalVisible.sync="modalVisible"
            :childData="childData"
			@cancel = cancel 
			@refreshData = getDataList>
		</v-operation-model>
    </div>
</template>

<script>
import {partnerList,partnerDelete} from "@/api/gjhzb";
import columData from '@/libs/columData'
import vOperationModel from "./opation.vue";
import vPage from "@/views/my-components/page.vue";
import { deleteEmptyParams,dateFormat } from '@/libs/tools.js'
import {getDictDataByType} from '@/api/index'
export default {
    name: "partner",
    data() {
        return {
            modalVisible:false,//添加或编辑弹窗
            loading:false, 
            searchForm: {
                partnerName:'',
                cooperationUnit:'',
                partnerNature:'',
                partnerType:'',
                pageNumber: 1, // 当前页数
                pageSize: 10, // 页面大小
            },
            total:0,//总条数
            columns:[],//表头
            data:[],//表格数据
            childData:{},
            partnerNatureList:[]
        };
    },
    components:{vOperationModel,vPage},
    created(){
        this.columns = columData['partner'].concat(columData['last_list'])
        this.getDataList();
        this.getDictData()
    },
    methods: {
        //获取数据字典
        getDictData(){
            //合作方性质
            getDictDataByType('partner_nature').then(res=>{
                if(res.success){
                    this.partnerNatureList = res.result
                }
            })
        },
        searchData(){
            this.searchForm.pageNumber = 1
            this.searchForm.pageSize = 10
            this.getDataList()
        },
        getDataList() {
            let params = {}
            params = deleteEmptyParams(this.searchForm)
            this.loading = true;
            partnerList(params).then((res) => {
                this.loading = false;
                if (res.success === true) {
                    this.data = res.result.records;
                    this.total = res.result.total;
                }
            });
        },
        handleReset() {
            this.searchForm = this.$options.data().searchForm
            this.getDataList();
        },
        //添加数据
        addData(){
            this.childData = {
				id:'',
				flag:false
			}
            this.modalVisible = true
        },
        editData(id){
            this.childData = {
				id:id,
				flag:true
			}
            this.modalVisible = true
        },
        deleteData(id,name){
            this.$Modal.confirm({
                title: "确认删除",
                content: `您确认要删除${name}?`,
                onOk: () => {
                    partnerDelete(id).then((res) => {
                        if (res.success) {
                            this.$Message.success("删除成功");
                            this.getDataList();
                        }
                    });
                },
            });
        },
        
        changePage(v) {
            this.searchForm.pageNumber = v;
            this.getDataList();
        },
        changePageSize(v) {
            this.searchForm.pageSize = v;
            this.getDataList();
        },
        //取消
        cancel(value){
            this.modalVisible = value
        }
    },
};
</script>